export const environment = {
	production: false,

	region: 'eu-west-1',

	identityPoolId: 'eu-west-1:e137ebb1-0d20-414f-8d49-66af4277ee2f',
	userPoolId: 'eu-west-1_wKedqNV8h',
	clientId: '78hohhdpg688c5859ikoqn35u1',
	clientName: 'M3S - UAT',
	
	s3Bucket : {
		bucketName : 'mmk-m3s-data-uat'
	},

	apiUrl : 'https://09m1h2jyta.execute-api.eu-west-1.amazonaws.com/uat'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts